import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const openWaterVenueListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fopen-water-venue.jpg?alt=media&token=9e9c0e55-db04-44fb-9525-d7810110a1c4",
  title: "Venues & Activity Centres",
  subtitle: "Run your Venue without all the Running",
  page: WildNavigationType.OPENWATERVENUE,
}